import { Divider, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { useApplicationStore } from "../../context/ApplicationStoreContext";

const OrderConfirmCard = () => {
  const { state } = useApplicationStore();

  return (
    <Paper variant="outlined">
      <Grid p={1}>
        <Stack spacing={0.3}>
          <Typography variant="caption">注文情報</Typography>
          <Divider />
          <Typography variant="body2">
            {state.orderInfoForm?.name}, {state.orderInfoForm?.amount}個
          </Typography>
          <Typography variant="body2">
          小計:{state.orderInfoForm?.total}円, 送料:{state.shippingFee}円
          </Typography>
          <Typography variant="body2" display="inline">
          合計:{state.orderInfoForm?.total! + state.shippingFee}円
          </Typography>
        </Stack>
      </Grid>
    </Paper>
  );
};
export default OrderConfirmCard;

